import Cookie from 'js-cookie';
import CryptoJS from 'crypto-js';
import URI from 'urijs';
import config from '../config/index';
import promisify from '@/utils/promisify';
import {
  PLATFORM,
  platform,
  isBrowser,
  isMobile,
  RUNTIME_ENV,
  isPPTVClient,
  isSulinkClient,
  isClient,
  comnParams,
  CHANNEL_IOS,
  CHANNEL_IPAD,
  CHANNEL_ANDROID,
  CHANNEL_HUAWEI,
  CHANNEL_WEB_WIN,
  CHANNEL_WEB_MAC,
  CHANNEL_CLIENT_WIN,
  CHANNEL_CLIENT_MAC,
} from './platform';

const dfpToken = comnParams.dfpToken || null;
const detect = comnParams.detect || null;
const channel = comnParams.channel || '';
const terminal = comnParams.terminal || '';

// 新版风控传参
const iarObj = {
  [CHANNEL_IOS]: {
    terminal: 'M-phone',
    termiSys: 'IOS',
  },
  [CHANNEL_IPAD]: {
    terminal: 'M-phone',
    termiSys: 'IOS',
  },
  [CHANNEL_ANDROID]: {
    terminal: 'M-phone',
    termiSys: 'Android',
  },
  [CHANNEL_HUAWEI]: {
    terminal: 'M-phone',
    termiSys: 'Harmony',
  },
  [CHANNEL_WEB_WIN]: {
    terminal: 'PC',
    termiSys: 'Windows',
  },
  [CHANNEL_CLIENT_WIN]: {
    terminal: 'PC',
    termiSys: 'Windows',
  },
  [CHANNEL_WEB_MAC]: {
    terminal: 'PC',
    termiSys: 'Macos',
  },
  [CHANNEL_CLIENT_MAC]: {
    terminal: 'PC',
    termiSys: 'Macos',
  },
};

const LoginTypeAuth = 'auth';
const LoginTypeLogin = 'login';

function isIE() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
}
function isJSONString(str) {
  if (typeof str == 'string') {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}
function myJSONParse(prop) {
  return isJSONString(prop) ? JSON.parse(prop) : prop;
}
/**
 * 获取当前href的登录类型，判断是授权登录还是常规登录
 *
 * @returns
 */
function getLoginType({ href } = {}) {
  const uri = new URI(href || window.location.href);
  const query = uri.query(true);
  // 兼容ppos
  const targetUrl = query.targetUrl || '';
  const targetUri = new URI(targetUrl);
  const targetQuery = targetUri.query(true);
  const returnUrl = query.returnUrl || '';
  const returnUri = new URI(returnUrl);
  const returnQuery = returnUri.query(true);
  if ((query.qrid || targetQuery.qrcode || returnQuery.qrcode) && query.appplt) {
    return LoginTypeAuth;
  }
  return LoginTypeLogin;
}
/**
 * 判断页面是否是从微信登录过来的
 *
 * @returns Boolean
 */
function isFromWechat() {
  return sessionStorage.getItem('fromWechat');
}
function setFromWechat(val = '') {
  if (val) {
    sessionStorage.setItem('fromWechat', val);
  } else {
    sessionStorage.removeItem('fromWechat');
  }
}
/**
 * 根据sessionStorage判断用户是否登录
 *
 * @returns
 */
function isLoginFromStorage() {
  return !!sessionStorage.getItem('username') && sessionStorage.getItem('token');
}

/**
 * 从storage获取userInfo
 *
 * @returns
 */
function getUserInfoFromStorage(type = 0) {
  const storage = type ? localStorage : sessionStorage;
  const userInfo = JSON.parse(storage.getItem('userInfo') || null);
  const username = storage.getItem('username');
  const token = storage.getItem('token');
  return { ...userInfo, username, token };
}

function setUserInfoToStorage(userInfo = {}, type = 0) {
  const storage = type ? localStorage : sessionStorage;
  const { username, token } = userInfo;
  if (!username || !token) {
    storage.removeItem('username');
    storage.removeItem('token');
    storage.removeItem('userInfo');
  } else {
    storage.setItem('username', username);
    storage.setItem('token', token);
    storage.setItem('userInfo', JSON.stringify(userInfo));
  }
}
function setCookie(key, value, params = {
  expires: 14,
  domain: document.domain.split('.').slice(-2).join('.'),
}) {
  Cookie.set(key, value, params);
}
function getCookie(key) {
  return Cookie.get(key);
}
/**
 * 根据cookie判断用户是否登录
 *
 * @returns
 */
function isLoginFromCookie() {
  return !!Cookie.get('PPName') && Cookie.get('ppToken');
}
/**
 * 将userInfo存入Cookie
 * async
 */
function setUserInfoToCookie(userInfo, expires = 14) {
  let resolveFun;
  const promise = new Promise((resolve) => {
    resolveFun = resolve;
  });
  const params = {
    expires,
    domain: document.domain.split('.').slice(-2).join('.'),
  };
  let pppassport = config.HOST.pppassport;
  let vippptv = config.HOST.vippptv;
  if (window.pplp_web_login_plugin_env) {
    pppassport = config[window.pplp_web_login_plugin_env].HOST.pppassport;
    vippptv = config[window.pplp_web_login_plugin_env].HOST.vippptv;
  }
  if (userInfo) {
    // 兼容旧版pptv登录
    const accountInfoPromise = promisify($.ajax.bind($), {
      url: `${pppassport}/v3/query/accountinfo.do`,
      data: {
        username: userInfo.username,
        token: userInfo.token,
        format: 'jsonp',
      },
      dataType: 'jsonp',
      jsonp: 'cb',
      jsonpCallback: `accountinfocb${(new Date()).valueOf()}`,
    });
    const cookiePromise = promisify($.ajax.bind($), {
      url: `${pppassport}/v3/cookies/query.do`,
      data: {
        username: userInfo.username,
        token: userInfo.token,
        format: 'jsonp',
      },
      dataType: 'jsonp',
      jsonp: 'cb',
      jsonpCallback: `querycookie${(new Date()).valueOf()}`,
    });
    const vipPromise = promisify($.ajax.bind($), {
      url: `${vippptv}/vip/getvipinfo`,
      data: {
        username: userInfo.username,
        token: userInfo.token,
        format: 'jsonp',
      },
      dataType: 'jsonp',
      jsonp: 'cb',
      jsonpCallback: `ueryvip${(new Date()).valueOf()}`,
    });
    Promise.all([accountInfoPromise, cookiePromise, vipPromise]).then((arr) => {
      const [accountResult] = arr[0] || {};
      const [cookieResult] = arr[1] || {};
      const [vipResult] = arr[2] || {};
      const accountInfo = accountResult.result || {};
      let { PPKey = '', PPName = '', UDI = '', newUDI = '', ppToken = '' } = cookieResult.result || {};
      const { grade, isvalid } = vipResult.vipinfo || {};
      PPKey = decodeURIComponent(PPKey);
      PPName = decodeURIComponent(PPName);
      UDI = decodeURIComponent(UDI);
      ppToken = decodeURIComponent(ppToken);
      newUDI = decodeURIComponent(newUDI);
      UDI = newUDI || UDI;
      Cookie.set('UDI', UDI, params);
      Cookie.set('UDR', UDI.split('$').slice(-1)[0], params);
      Cookie.set('PPName', PPName, params);
      Cookie.set('ppToken', ppToken, params);
      Cookie.set('PPKey', PPKey, params);
      Cookie.set('ppid', accountInfo.ppId, params);
      Cookie.set('nickname', accountInfo.nickname, params);
      Cookie.set('username', accountInfo.username, params);
      Cookie.set('avatar', accountInfo.facePic, params);
      Cookie.set('utp', isvalid, params);
      Cookie.set('vipType', grade, params);
      resolveFun();
    });
  } else {
    // 兼容旧版pptv登录
    Cookie.remove('UDI', params);
    Cookie.remove('UDR', params);
    Cookie.remove('PPName', params);
    Cookie.remove('ppToken', params);
    Cookie.remove('PPKey', params);
    Cookie.remove('ppid', params);
    Cookie.remove('utp', params);
    Cookie.remove('vipType', params);
    resolveFun();
  }
  return promise;
}
/**
 * 从cookie获取userInfo
 *
 * @returns
 */
async function getUserInfoFromCookie() {
  const cookie = Cookie.getJSON();
  // 老版cookie
  const ppName = cookie.PPName || '';
  let username = ppName.split('$')[0];
  let token = cookie.ppToken || '';
  // 本地项目存的cookie
  if (cookie.userInfo && cookie.username && cookie.token) {
    username = cookie.username || '';
    token = cookie.token || '';
  }
  let pppassport = config.HOST.pppassport;
  if (window.pplp_web_login_plugin_env) {
    pppassport = config[window.pplp_web_login_plugin_env].HOST.pppassport;
  }
  let result = {};
  if (username && token) {
    try {
      const res = await promisify($.ajax.bind($), {
        url: `${pppassport}/v3/cookies/query.do`,
        data: {
          username,
          token,
          format: 'jsonp',
        },
        dataType: 'jsonp',
        jsonp: 'cb',
        jsonpCallback: `querycookiev${(new Date()).valueOf()}`,
      });
      const [resObj = {}] = res || [];
      let { PPName, UDI, ppToken } = resObj.result || {};
      if (PPName && UDI && ppToken) {
        // 如果没有进判断，大概率token失效
        PPName = decodeURIComponent(PPName);
        UDI = decodeURIComponent(UDI);
        ppToken = decodeURIComponent(ppToken);
        username = ppName.split('$')[0];
        token = ppToken;
        const arr = UDI.split('$');
        const facepic = arr[9] || '';
        const nickname = arr[16] || '';
        result = {
          username,
          token,
          facepic,
          imgUrl: facepic,
          nickname,
        };
      } else {
        // 清空cookie
        setUserInfoToCookie();
      }
    } catch (error) {
      console.log('error...', error);
    }
  }
  return result;
  // if (cookie.userInfo && cookie.username && cookie.token) {
  //   return { ...cookie.userInfo, username: cookie.username, token: cookie.token };
  // } else {
  //   // 旧版pp视频登录
  //   const ppName = cookie.PPName || '';
  //   const username = ppName.split('$')[0];
  //   const token = cookie.ppToken;

  //   const udi = decodeURIComponent(cookie.UDI || '');
  //   const arr = udi.split('$');
  //   const facepic = arr[9] || '';
  //   const nickname = arr[16] || '';
  //   return { username, token, facepic, imgUrl: facepic, nickname };
  // }
}
async function getUserInfo() {
  const thisUri = new URI(window.location.href);
  const thisQuery = thisUri.query(true);
  const { username = '', token = '', nickname = '', imgUrl = '', mobile = '' } = thisQuery;
  if (thisQuery.username && thisQuery.token) {
    return { username, token, nickname, imgUrl, mobile };
  } else {
    return await getUserInfoFromCookie() || {};
  }
}

const WhiteList = ['suning.com', 'cnsuning.com', 'pptv.com', 'ppsport.com', 'cibntv.net', 'hifuntv.com'];
/**
 * 检查targetUrl
 *
 * @param {*} url
 * @returns
 */
function checkTargetUrl(url) {
  if (url === undefined || url === null || url === '' || url === 'undefined' || url === 'null') {
    return true;
  }
  const uri = new URI(url);
  const protocol = uri.protocol();
  const protocolReg = /^http(s?)(:?)$/;
  // 协议不是http或https，返回false
  if (!protocolReg.test(protocol)) {
    return false;
  }

  const domain = uri.domain();
  if (!WhiteList.find(item => item === domain)) {
    return false;
  }
  return true;
}

/**
 * 将传入的params拼入url，并跳转
 *
 * @param {*} url
 * @param {*} [params={}]
 * @returns
 */
async function gotoTargetUrl(url, params = {}, _blank = false) {
  if (`${url}` === 'undefined' || `${url}` === 'null' || url === '') {
    return;
  }

  let uri; let query; let newUrl;
  if (url.match(/#\/\w+(\?)?/ig)) {
    let hashUrl = url.match(/#\/\w+(\?)?/ig) ? url.match(/#\/\w+(\?)?/ig)[0] : '';
    hashUrl = hashUrl.replace(/\?/ig, '');
    let queryUrl = url.replace(/#\/\w+(\?)?/ig, '?');
    if (queryUrl.indexOf('?') == queryUrl.length - 1) {
      queryUrl = queryUrl.replace(/\?/ig, '');
    }
    uri = new URI(queryUrl);
    uri.setQuery(params);
    query = uri.query(true);
    // 防止微信环境中，跳出页面之后，重新登录，无法进入微信登录页面
    if (!config.HOST.pplp.includes(uri.host()) && WhiteList.includes(uri.domain())) {
      setFromWechat();
    }
    newUrl = uri.toString();
    newUrl = `${newUrl.split('?')[0]}${hashUrl}?${newUrl.split('?')[1]}`;
  } else {
    uri = new URI(url);
    uri.setQuery(params);
    query = uri.query(true);
    // 防止微信环境中，跳出页面之后，重新登录，无法进入微信登录页面
    if (!config.HOST.pplp.includes(uri.host()) && WhiteList.includes(uri.domain())) {
      setFromWechat();
    }
    newUrl = uri.toString();
  }

  let result = null;
  // 判定当前域名和升级一账通域名于跳转地址的主域名是否相同
  const isgoToPpwfsTrustLogin = [window.location.host, config.HOST.reg].some((item) => {
    const newitemuri = new URI(item);
    return newitemuri.domain() === uri.domain();
  });
  if (isClient) {
    if (newUrl.match(/open\.weixin\.qq\.com/gi)) {
      window.ppObject.invokeMethod('loginRedirect', newUrl, 760, 460);
    } else {
      window.ppObject.invokeMethod('loginRedirect', newUrl, 760, 380);
    }
  } else if (_blank) {
    var iWidth = 600;
    var iHeight = 400;
    var iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;  
    var iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
    result = window.open(newUrl, 'newwindow', "height=" + iHeight + ",width=" + iWidth + ",top=" + iTop + ",left=" + iLeft + ",toolbar=no,menubar=no,scrollbars=no, resizable=yes,location=yes, status=no");
  } else if (!isgoToPpwfsTrustLogin && !['cibntv.net','hifuntv.com'].includes(uri.domain()) && query.username && query.token) {
    // window.location.host !== uri.host() 当前域名内的跳转，不做限制!!!否则auth页面或者微信登录页面等需要使用url参数获取用户信息的页面，将无法获取登录信息，导致无法登录
    // config.HOST.reg 不做控制
    // cibntv.net 不做控制，直接参数放在url后面做页面跳转
    // 登录成功跳转
    // 将userInfo存入cookie
    const username = query.username;
    const token = query.token;
    // setCookie('username', username);
    // setCookie('token', token);
    await setUserInfoToCookie({
      username,
      token,
    });
    ['username', 'token', 'imgUrl', 'nickname', 'mobile'].forEach((key) => {
      delete query[key];
    });
    // 覆盖参数
    uri.query(false).setQuery(query);
    const middleUri = new URI(`${config.HOST.ppwfs}/pplp/trustLogin`);
    middleUri.setQuery({
      targetUrl: uri.toString(),
      username,
      token,
    });
    const middleUrl = middleUri.toString();
    window.location.href = middleUrl;
  } else if (query.username && query.token) { // 新增一种，如果调用时候传了username 和 token，就把suning.com域名下面写cookie
    // 将userInfo存入cookie
    const username = query.username;
    const token = query.token;
    await setUserInfoToCookie({
      username,
      token,
    });
    window.location.href = newUrl;
  } else {
    // 普通重定向
    window.location.href = newUrl;
  }
  return result;
}

/**
 * 修改链接的href，删除原href中的指定query参数
 */
function removeUrlStates(queryKeys = []) {
  const uri = new URI(window.location.href);
  queryKeys.forEach(key => uri.removeQuery(key));
  window.history.replaceState({}, '', uri.href());
}

function addUrlState(querys = []) {
  const uri = new URI(window.location.href);
  querys.forEach(item => uri.addQuery(item.key, item.value));
  window.history.replaceState({}, '', uri.href());
}

/**
 * 跳注册页面
 * @param {*} params
 */
function toRegister(params = {}) {
  if (isMobile) {
    gotoTargetUrl(`${config.HOST.pplp}/sn-register`, params);
  } else {
    gotoTargetUrl(`${config.HOST.snreg}/person.do`, {}, true);
  }
}

/**
 * 跳忘记密码页面
 * @param {*} params
 */
function toResetPassword(params = {}) {
  // 易购方面要求，需要对参数进行重新处理
  let nextTargetUrl = params.nextTargetUrl || '';
  const nextTargetUri = new URI(nextTargetUrl);
  const search = nextTargetUri.search().slice(1);
  nextTargetUrl = `${nextTargetUri.href().split(search)[0]}${encodeURIComponent(search)}`;
  params.nextTargetUrl = encodeURIComponent(nextTargetUrl);
  gotoTargetUrl(`${config.HOST.aq}/asc/wap/forgetpsw/show_0.do`, params);
}

/* eslint-disable dot-notation */
/** 账号校验接口，获取ip, status验证是否需要升级，0未升级，1已升级过
 */
const isUpgrade = async (username, token) => {
  const fingerprintToken = window['_dfp'].getToken();
  const params = {
    username: decodeURIComponent(username),
    token: decodeURIComponent(token),
    channel,
    scene: 'REG_PPTVUP_WAP',
    dfpToken,
    format: 'jsonp',
    cb: 'isUpgrade',
  };
  const [result] = await promisify(window.$.ajax.bind(window.$), {
    url: `${config.HOST.pppassport}/isUpgrade`,
    data: params,
    dataType: 'jsonp',
    jsonp: 'cb',
    jsonpCallback: 'isUpgrade',
  });
  return result;
};
/**
 * 跳转一账通升级页
 * @param {*} params
 * 入参username，token，ppid，targetUrl必传参数
 */
const toGeneralLedger = async (params = {}) => {
  const { username = '', token = '', ppid = '', targetUrl = '' } = params;
  if (!username || !token) { console.log("###@==>", "no user_info"); return false; }
  const { ip = '', status = '', errorCode = '' } = await isUpgrade(username, token);
  const param = {
    username,
    token,
    extBusRef: ppid,
    targetUrl,
    ip,
    deviceId: dfpToken,
    dfpToken,
    channel,
    isUpdate: true,
    upgradeSource: 1,
    sceneFlag: 2,
  };
  if (+status === 0 && errorCode != "6") {
    gotoTargetUrl(`${window.location.protocol}${config.HOST.reg}/pptv/popupupgrade_2.do`, param, !isMobile);
  } else if (+status === 1 || errorCode == "6") {
    const userInfo = { ...params };
    return userInfo;
  }
};

// 检测是否要走新风控
const isGoNewRisk = () => new Promise(async (resolve, reject) => {
  const [data] = await promisify(window.$.ajax.bind(window.$), {
    url: `${config.HOST.pppassport}/login/risk/loginRiskFlag`,
    data: {
      cb: 'newUPloginRiskFlag',
      format: 'jsonp',
    },
    dataType: 'jsonp',
    jsonp: 'cb',
    jsonpCallback: 'newUPloginRiskFlag',
    context: this,
    error(XMLHttpRequest, textStatus) {
      reject(0);
    },
  });
  if (data.errorCode == "0") {
    if (data.result == '1') {
      resolve(1);
    } else {
      reject(0);
    }
  } else {
    reject(0);
  }
});

// 检测是否新的走风控的二维码
const isGoNewQrcode = qrId => new Promise(async (resolve, reject) => {
  const [data] = await promisify(window.$.ajax.bind(window.$), {
    url: `${config.HOST.pppassport}/login/risk/qrCode/isNewCode`,
    data: {
      qrId,
      cb: 'newisGoNewQrcode',
      format: 'jsonp',
    },
    dataType: 'jsonp',
    jsonp: 'cb',
    jsonpCallback: 'newisGoNewQrcode',
    context: this,
    error(XMLHttpRequest, textStatus) {
      reject(0);
    },
  });
  if (data.errorCode == "0") {
    if (data.result && data.result.isNewCode) {
      resolve(1);
    } else {
      reject(0);
    }
  } else {
    reject(0);
  }
});

/**
 * 跳转qq/sina登录
 * @param {*} params
 * type区分qq和微博，必传；
 * returnurl非必传，重定向url，默认http://www.pptv.com
 */
const toLoginQqAndSina = async (params = {}) => {
  const { type = '', returnurl = '' } = params;
  const uri = new URI(window.location.href);
  const { appplt = '', channel: channelcode = '', appid: statAppid = '' } = uri.query(true);
  let isnewrisk;
  try {
    isnewrisk = await isGoNewRisk();
  } catch (e) {
    isnewrisk = e;
  }
  if (isnewrisk === 1) {
    const param = {
      thirdAppType: type,
      loginChannel: channel,
      terminal: iarObj[channel].terminal,
      termiSys: iarObj[channel].termiSys,
      appType: 'browser',
      businessId: 'unionmsg',
      from: 'web',
      version: '1',
      referenceURL: window.location.origin,
      returnurl,
      dfpToken,
    };
    const newWindow = gotoTargetUrl(`${window.location.protocol}${config.HOST.pppassport}/login/risk/thirdPartyLogin`, param, !isMobile);
    return newWindow;
  } else {
    const param = {
      apptype: type,
      from: 'web',
      version: '1',
      returnurl,
      format: 'redirect',
      appplt,
      channelcode,
      statAppid,
    };
    const newWindow = gotoTargetUrl(`${window.location.protocol}${config.HOST.pppassport}/thirdPartyLoginApi.do`, param, !isMobile);
    return newWindow;
  }
};

function getClientStorage(key = '') {
  return new Promise((resolve, reject) => {
    window.ppQuery({
      request: key,
      onSuccess(message) {
        resolve(message);
      },
      onFailure() {
        reject({
          data: '',
        });
      },
    });
  });
}
async function getLocalStorage(key) {
  let res = '';
  if (isClient) {
    res = await getClientStorage(key);
  } else {
    res = localStorage.getItem(key);
  }
  if (!res || res === 'undefined' || res === 'null') {
    res = '';
  }
  return res;
}
function setLocalStorage(key, value = '') {
  if (isClient) {
    window.ppObject.invokeMethod('set', key, value);
  } else {
    localStorage.setItem(key, value);
  }
}

async function thurlSuningPassport(params) {
  await promisify(window.$.ajax.bind(window.$), {
    url: `${config.HOST.snpassport}/ids/logout`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: {
      jsonViewType: true,
      format: 'jsonp',
    },
    dataType: 'jsonp',
    jsonp: 'callback',
    jsonpCallback: 'callback',
  });
  const [res] = await promisify(window.$.ajax.bind(window.$), {
    url: `${config.HOST.pppassport}/trust/login`,
    data: {
      username: params.username,
      token: params.token,
      type: 'suning',
      loginChannel: channel,
      format: 'jsonp',
    },
    dataType: 'jsonp',
    jsonp: 'cb',
    jsonpCallback: 'callback',
  });
  if (res.result && res.result.redirectUrl) {
    const uri = new URI(`${window.location.origin}/pc/suning-passport-return`);
    uri.setQuery({
      userInfo: JSON.stringify(params),
    });
    gotoTargetUrl(decodeURIComponent(res.result.redirectUrl), {
      targetUrl: uri.toString(),
    });
  }
}
// 通知客户端登录成功
function postClientLogined(params = {}) {
  if (window.ppObject) {
    if (params.token) {
      console.log('client loginfinished');
      params.token = encodeURIComponent(params.token || '');
      params.loginType = 1; // 客户端需要区分登录场景，目前只有账密登录，后期扫码登录完善之后，需要判断登录场景做相应传参
      window.ppObject.invokeMethod('loginFinished', JSON.stringify(params));
    } else {
      console.log('client close');
      window.ppObject.invokeMethod('loginFinished');
    }
  }
}
// 通知客户端支付结果
function postClientPaid(state) {
  if (window.ppObject) {
    window.ppObject.invokeMethod("Web_Payment_PayState", state);
  }
}

export {
  LoginTypeAuth,
  LoginTypeLogin,
  getLoginType,
  isFromWechat,
  setFromWechat,
  isLoginFromStorage,
  isLoginFromCookie,
  setUserInfoToStorage,
  getUserInfoFromStorage,
  setUserInfoToCookie,
  getUserInfoFromCookie,
  getUserInfo,
  WhiteList,
  checkTargetUrl,
  gotoTargetUrl,
  removeUrlStates,
  addUrlState,
  toRegister,
  toResetPassword,
  toGeneralLedger,
  isGoNewRisk,
  isGoNewQrcode,
  toLoginQqAndSina,
  getLocalStorage,
  setLocalStorage,
  thurlSuningPassport,
  postClientLogined,
  PLATFORM,
  platform,
  isBrowser,
  isMobile,
  RUNTIME_ENV,
  isPPTVClient,
  isSulinkClient,
  isClient,
  comnParams,
  CHANNEL_IOS,
  CHANNEL_IPAD,
  CHANNEL_ANDROID,
  CHANNEL_HUAWEI,
  CHANNEL_WEB_WIN,
  CHANNEL_WEB_MAC,
  CHANNEL_CLIENT_WIN,
  CHANNEL_CLIENT_MAC,
  myJSONParse,
  isIE,
  getCookie,
  setCookie,
  isUpgrade,
  getClientStorage,
  postClientPaid,
};
